import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import {Button, Card} from 'react-bootstrap/';
import appleMusic from './media/appleMusic.svg';
import spotify from './media/spotify.svg';
import './Home.css';
import warning from './media/warning.webp';
import logo from './media/BESTAW.webp';
import shirt from './media/shirt.webp';
import footer from './media/calibucky.webp';
import SHINE from './media/SHINE.mp3'
import ReactPlayer from 'react-player'

// Render a YouTube video player



class Home extends React.Component { 

  constructor() {
    super();
    this.state = { 
      entered: false,
    };

    
    
  }


  
 
  componentDidMount()
  {
    
  }


  componentDidUpdate( )
  { 

  }
  
  render()
  {  

    return (
      <div className="rain" id="rain">

        
      <div className="pageContainer">  

      <audio loop id="preview">
      <source src={SHINE} type="audio/mpeg"/>
     
    </audio>
      

      
        {!this.state.entered && <div className='vertical-center'>
          <div className='container'>
      
            <img src={warning} className="warning"></img>
            <Button size="lg" className='button' onClick={() => {
              this.setState({entered: true});

              var x = document.getElementById("preview"); 
              //x.play();

              var y = document.getElementById("rain");
             //console.log(y)

             
document.getElementById('rain').className = "rain2"
console.log(document.getElementById("rain"))
              //y.style.backgroundImage = lightning;

              //console.log(y)
          }
            
            }>ENTER</Button>
          </div>
          </div>}

        {this.state.entered && 
        <div className='container'>
          <source src={SHINE} type="audio/mpeg"></source>
    
          <img src={logo} className="logo"></img>
          <div className='content'>
          <div
                className="video"
                style={{
                  position: "relative",
                  paddingBottom: "56.25%",
                  paddingTop: 25,
                  height: 0,
                  
                }}>
                  
                  <iframe
                    style={{
                      position: "absolute",
                      top: '50%',
                      left: '50%',
                      width: "80%",
                      height: "80%",
                      alignSelf: 'center',
                      backgroundColor: 'transparent',
                    
                      transform: 'translate(-50%, -50%)'
                    }}
                    src={`https://www.youtube.com/embed/dRZDwPlIOBY`}
                    frameBorder="0"
                  />
                  
                  </div>
          <Card className="card" >
     
      <Card.Body>
        <center>

        <h1>OUT NOW</h1>
        <div className='socialContainer'>
        <a href="https://music.apple.com/us/artist/calibucky/1474081743" target="_blank" className='socialItem'><img src={appleMusic} className='social'></img></a>
                <a href="https://open.spotify.com/artist/6TfXWmwlloHQ3TIlNtEPa8" target="_blank" className='socialItem'><img src={spotify} className='social'></img></a>
                
                
              </div>
        <h2 style={{marginTop: '1em'}}>PICK YOURS</h2>

        </center>
      
      </Card.Body>
    </Card>
    <center>
    <img src={shirt} className="shirt"></img>
    <br></br>
    <Button size="lg" className='button2' onClick={() => {window.open("https://www.jaevalid.com/product/warning-cali-bucky-collab", '_blank').focus();}}>BUY NOW</Button>
    <br></br>
    <img src={footer} className="footer" style={{marginTop: '2.5em'}} onClick={() => {window.open("https://www.instagram.com/calibucky", '_blank').focus();}}></img>
    </center>

   
          </div>
          
        </div>
  }




        
      </div>
      </div>
      )
    
    
          
      
  }
}
export default Home;
